import cn from "classnames";
import { If } from "components";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";

import { ProfileSummaryCardsProps } from "./ProfileSummaryCards.types";

import styles from "./ProfileSummaryCards.module.scss";

/**
 * The KPI tiles above a profile tab's table. Deliberately dumb: every value is
 * pre-formatted by the caller, because some of them are money and some are counts.
 */
const ProfileSummaryCards = ({
  cards,
  isLoading,
  className
}: ProfileSummaryCardsProps) => {
  return (
    <div className={cn(styles.cards, className)}>
      {cards.map((card) => (
        <div
          key={card.label}
          className={cn(styles.card, {
            [styles.card__primary]: card.accent === "primary",
            [styles.card__success]: card.accent === "success",
            [styles.card__warning]: card.accent === "warning"
          })}
        >
          <div className={styles.card_label}>
            {card.icon}
            {t(card.label)}
          </div>

          {isLoading ? (
            <Skeleton className={styles.card_skeleton} count={1} />
          ) : (
            <div
              className={cn(styles.card_value, {
                [styles.card_value__primary]: card.accent === "primary",
                [styles.card_value__success]: card.accent === "success",
                [styles.card_value__warning]: card.accent === "warning"
              })}
            >
              {card.value}
            </div>
          )}

          <If condition={card.hint !== undefined && !isLoading}>
            <div className={styles.card_hint}>{card.hint}</div>
          </If>
        </div>
      ))}
    </div>
  );
};

export default ProfileSummaryCards;
